import { SYSTEM_GAME_SETTINGS_UPDATE } from 'socket-resources/event-constants/common/index'
import { SYSTEM } from 'socket-resources/namespaces/index'
import { io } from 'socket.io-client'

const useGameSettingsUpdateSocketNameSpace = () => {
  const listenGameSettingsUpdate = (cb) => {
    const gameSettingsUpdateInstance = io(`${process.env.REACT_APP_BACKEND_URL_WS}${SYSTEM}`, {
      transport: ['polling', 'websocket']
    })
    if (cb) {
      gameSettingsUpdateInstance.on(SYSTEM_GAME_SETTINGS_UPDATE, cb)
    }
    return () => {
      gameSettingsUpdateInstance.off(SYSTEM_GAME_SETTINGS_UPDATE, cb)
    }
  }

  return listenGameSettingsUpdate
}

export default useGameSettingsUpdateSocketNameSpace
